// extracted by mini-css-extract-plugin
export default {"container":"Currency_container__8ngJN"};